module.exports = __webpack_public_path__ + "04_long_gold.c8b9f6c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_long_gold.png
// module id = tb25
// module chunks = 0